// Writes your routes here

// Configuaration (TEST)
// Service Type Api
export const serviceTypeApi = 'configuration/service-type/list'
export const serviceTypeStoreApi = 'configuration/service-type/store'
export const serviceTypeUpdateApi = 'configuration/service-type/update'
export const serviceTypeToggleStatusApi = 'configuration/service-type/toggle-status'

// Service Process Step
const serviceProcessStepBase = 'configuration/service-process-step'
export const serviceProcessStepListApi = serviceProcessStepBase + '/list'
export const serviceProcessStepStoreApi = serviceProcessStepBase + '/store'
export const serviceProcessStepUpdateApi = serviceProcessStepBase + '/update'
export const serviceProcessStepToggleStatusApi = serviceProcessStepBase + '/toggle-status'

// Service Process Avail
const serviceProcessAvailBase = 'configuration/service-process-avail'
export const serviceProcessAvailListApi = serviceProcessAvailBase + '/list'
export const serviceProcessAvailShowApi = serviceProcessAvailBase + '/show'
export const serviceProcessAvailStoreApi = serviceProcessAvailBase + '/store'
export const serviceProcessAvailUpdateApi = serviceProcessAvailBase + '/update'

// Patient Category Api
export const patientCategoryApi = 'configuration/patient-category/list'
export const patientCategoryStoreApi = 'configuration/patient-category/store'
export const patientCategoryUpdateApi = 'configuration/patient-category/update'
export const patientCategoryToggleStatusApi = 'configuration/patient-category/toggle-status'

// Event Info Setup Api
export const eventInfoSetupApi = 'configuration/event-info-setup/list'
export const eventInfoStoreApi = 'configuration/event-info-setup/store'
export const eventInfoUpdateApi = 'configuration/event-info-setup/update'
export const eventInfoToggleStatuseApi = 'configuration/event-info-setup/toggle-status'

// Event Info Setup Api
export const stallSetupApi = 'configuration/stall-setup/list'
export const stallStoreApi = 'configuration/stall-setup/store'
export const stallUpdateApi = 'configuration/stall-setup/update'
export const stallToggleStatuseApi = 'configuration/stall-setup/toggle-status'

// Event Type Setup Routes
export const EventTypeApi = 'configuration/event-type/list'
export const EventTypeStoreApi = 'configuration/event-type/store'
export const EventTypeUpdateApi = 'configuration/event-type/update'
export const EventTypeToggleStatusApi = 'configuration/event-type/toggle-status'

// Fair Stall Fee Setup Routes
export const FairStallApi = 'configuration/fair-stall/list'
export const FairStallStoreApi = 'configuration/fair-stall/store'
export const FairStallUpdateApi = 'configuration/fair-stall/update'
export const FairStallToggleStatusApi = 'configuration/fair-stall/toggle-status'

// Faq list Routes
export const faqListApi = 'configuration/faq-setup/index'
export const faqStoreApi = 'configuration/faq-setup/store'
export const faqUpdateApi = 'configuration/faq-setup/update'
export const faqDeleteApi = 'configuration/faq-setup/destroy'
export const faqToggleStatus = 'configuration/faq-setup/toggle-status'

// Supplier Type Setup Routes
export const supplierListApi = 'configuration/supplier-setup/index'
export const supplierStoreApi = 'configuration/supplier-setup/store'
export const supplierUpdateApi = 'configuration/supplier-setup/update'
export const supplierDeleteApi = 'configuration/supplier-setup/destroy'
export const supplierToggleStatus = 'configuration/supplier-setup/toggle-status'

// eligibility-category
export const eligibilityCatListApi = 'configuration/eligibility-category/list'
export const eligibilityCatStoreApi = 'configuration/eligibility-category/store'
export const eligibilityCatUpdateApi = 'configuration/eligibility-category/update'
export const eligibilityCatToggleStatusApi = 'configuration/eligibility-category/toggle-status'
// Fair Evaluation Setup Api

export const fairEvaluationListApi = 'configuration/fair-evaluation-setup/list'
export const fairEvaluationStoreApi = 'configuration/fair-evaluation-setup/store'
export const fairEvaluationUpdateApi = 'configuration/fair-evaluation-setup/update'
export const fairEvaluationToggleStatusApi = 'configuration/fair-evaluation-setup/toggle-status'
export const fairEvaluationShowApi = 'configuration/fair-evaluation-setup/show'

// Report Heading
export const reportHeadingList = 'configuration/report-heading/list'
export const reportHeadingStore = 'configuration/report-heading/store'
export const reportHeadingUpdate = 'configuration/report-heading/update'
export const reportHeadingDetail = 'configuration/report-heading/detail'
export const reportToggleStatus = 'configuration/report-heading/toggle-status'

// Stall Type Api
export const stallTypeApi = 'configuration/stall-type/list'
export const stallTypeStoreApi = 'configuration/stall-type/store'
export const stallTypeUpdateApi = 'configuration/stall-type/update'
export const stallTypeToggleStatusApi = 'configuration/stall-type/toggle-status'

// Education Level Api
export const educationLevelListApi = 'configuration/education-level/list'
export const educationLevelStoreApi = 'configuration/education-level/store'
export const educationLevelUpdateApi = 'configuration/education-level/update'
export const educationLevelToggleStatusApi = 'configuration/education-level/toggle-status'
// Group Api Route
export const groupList = 'configuration/group/list'
export const groupStoreApi = 'configuration/group/store'
export const groupUpdateApi = 'configuration/group/update'
export const groupToggleStatusApi = 'configuration/group/toggle-status'

// Institute Api Route
export const instituteDataList = 'configuration/institute/list'
export const instituteStoreApi = 'configuration/institute/store'
export const instituteUpdateApi = 'configuration/institute/update'
export const instituteToggleStatusApi = 'configuration/institute/toggle-status'

// Master skill Api
export const skillListApi = 'configuration/skill/list'
export const skillStoreApi = 'configuration/skill/store'
export const skillUpdateApi = 'configuration/skill/update'
export const skillToggleStatusApi = 'configuration/skill/toggle-status'

// Master Degree Api
export const DegreeListApi = 'configuration/degree/list'
export const DegreeStoreApi = 'configuration/degree/store'
export const DegreeUpdateApi = 'configuration/degree/update'
export const DegreeToggleStatusApi = 'configuration/degree/toggle-status'
